import { images } from '_/space-management/assets';
import { AuthProvider } from '_/space-management/hooks/AuthContext';
import { OrganizationProvider } from '_/space-management/hooks/OrganizationContext';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Asset } from 'expo-asset';
import { DateProvider } from '_/space-management/hooks/DateContext';
import { EventProvider } from '_/space-management/hooks/EventContext';
import { LocationProvider } from '_/space-management/hooks/LocationContext';
import { NotificationProvider } from '_/space-management/hooks/NotificationsContext';
import { ReportsProvider } from '_/space-management/hooks/ReportsContext';
import { SlotProvider } from '_/space-management/hooks/SlotContext';
import { SpaceProvider } from '_/space-management/hooks/SpaceContext';

export function SpaceManagementProviders({ children }: PropsWithChildren) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadAsync() {
      try {
        await Asset.loadAsync(Object.values(images));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }

    loadAsync();
  }, []);
  if (loading) {
    return null;
  }

  return (
    <AuthProvider>
      <OrganizationProvider>
        <NotificationProvider>
          <LocationProvider>
            <SpaceProvider>
              <DateProvider>
                <SlotProvider>
                  <ReportsProvider>
                    <EventProvider>{children}</EventProvider>
                  </ReportsProvider>
                </SlotProvider>
              </DateProvider>
            </SpaceProvider>
          </LocationProvider>
        </NotificationProvider>
      </OrganizationProvider>
    </AuthProvider>
  );
}
